import { useIntl } from "react-intl";
import { Field } from "react-final-form";
import { TextInput } from "../../../common/fields";
import * as Validations from "../../../common/form/validator";

const SetpasswordForm = () => {
  const intl = useIntl();

  return (
    <div className="grid">
      <div className="col-12 md:col-6 lg:col-6">
        <Field
          type="password"
          name="newPassword"
          component={TextInput}
          label={intl.formatMessage({
            id: "new_password",
          })}
          placeholder={intl.formatMessage({
            id: "new_password",
          })}
          required
          validate={Validations.composeValidators(
            Validations.required,
            Validations.validateStrongPassword
          )}
        />
      </div>
      <div className="col-12 md:col-6 lg:col-6">
        <Field
          type="password"
          name="conf_new_password"
          component={TextInput}
          label={intl.formatMessage({
            id: "conf_new_password",
          })}
          placeholder={intl.formatMessage({
            id: "conf_new_password",
          })}
          required
          validate={Validations.composeValidators(
            Validations.required,
            Validations.checkConfirmPassword
          )}
        />
      </div>
    </div>
  );
};

export default SetpasswordForm;
